import type React from 'react';

import { useStepManageAccessOwners } from '@/hooks/manageAccess/useStepManageAccessOwners';
import StepOwnersView from '@/components/organism/CreateSix/steps/StepOwners/StepOwners.view';

export interface StepManageAccessOwnersProps {
  onClose: () => void;
}

function StepManageAccessOwners(props: StepManageAccessOwnersProps): React.JSX.Element {
  void props;

  const { state, handlers } = useStepManageAccessOwners();

  return (
    <StepOwnersView
      selectedOwners={state.selectedOwners}
      candidateOwners={state.candidateOwners}
      searchValue={state.searchValue}
      onSearchValueChange={handlers.handleSearchChange}
      onRemoveOwner={handlers.handleRemoveOwner}
      onAddOwner={handlers.handleAddOwner}
    />
  );
}

StepManageAccessOwners.displayName = 'StepManageAccessOwners';

export default StepManageAccessOwners;
